/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 54,
  image: "default-changelog-v2.png",
  title: "Increased Compute Resources, Enhanced Deposit & Compute Topup, Design System & Platform Updates",
  shortDescription: "Increased Compute Resources and APAC Region Expansion, Revamped deposit & compute credits flow, design system upgrades, personalized login preferences, discounts on compute templates, and platform improvements & fixes for enhanced performance, accuracy, and usability.",
  description: "Increased Compute Resources and APAC Region Expansion, Revamped deposit & compute credits flow, design system upgrades, personalized login preferences, discounts on compute templates, and platform improvements & fixes for enhanced performance, accuracy, and usability.",
  date: "Jan 18th, 2024",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Deposit", "Scaling", "topup", "billing", "Login preference", "Compute", "Design system", "Enhancement", "performance", "fixes"]
};
export const content = `
Increased Compute Resources and APAC Region Expansion
----------------------------------------------

In the past week, we've significantly scaled our compute resources **from 256 to over 1000 CPU in both us-east and us-west regions**, promising a more robust and responsive computing experience. Simultaneously, we're thrilled to unveil our latest expansion – **a brand-new APAC region strategically located in Singapore**. This addition not only broadens our global reach but ensures users in the Asia-Pacific region benefit from enhanced performance and reduced latency.

## Improved Deposit & Compute Credits Top-up UX

We have added significant enhancements to the deposit and top-up experience on our platform, particularly for Spheron Wallet transactions and Compute Credits. These updates aim to provide a smoother and more reliable journey for our users. Here are the details:

**Enhancements to Deposit Flow and Top-Up:**

- **Streamlined UX and UI Design Upgrade:**
  - The deposit flow to Spheron Wallet and top-up for Compute Credits have undergone substantial refinements, enhancing both the user experience and the visual appeal of our interface.
- **Minimum Amount Limit:**
  - Introducing a minimum deposit and top-up amount limit of $15. This ensures that transactions meet a baseline amount, contributing to a more efficient and streamlined process.
- **Extra 1% Charge:**
  - To mitigate the impact of cryptocurrency slippage and ensure a seamless Compute journey, an additional 1% charge has been added to deposit and top-up transactions. This supplementary charge helps prevent potential disruptions and ensures the instance deployments remains unaffected.

## Design System Updates

We have made a significant upgrade to our design system that brings a more consistent and uniform look to the entire platform. This update introduces a variety of new UI components aimed at enhancing user experience and maintaining a cohesive theme across all aspects of our platform.

- **New UI Components:**
  - **Radio:** A user-friendly radio component for selecting options within a set.
  - **Switch:** Introducing a sleek and intuitive switch component for seamless toggling between options.
  - **Checkbox:** Enhance your interaction with our new checkbox component, making multi-selection easy and visually appealing.
  - **Empty State UI:** We've added an empty state UI to provide a cleaner and more informative display when there is no content to show.
  - **Feedback:** Easily convey feedback to users with our new feedback component, ensuring a more interactive and responsive experience.
  - **Toast Notification:** Stay informed with toast notifications, offering non-intrusive alerts for important updates.
  - **Links:** Enjoy a more refined and consistent linking experience across the platform.
  - **Badges:** To add context and highlight important information with our new badge component.
- **Consistency Across the Platform:**
  - We've meticulously designed these components to ensure a uniform appearance and behavior throughout the entire platform, creating a seamless and visually cohesive user interface.
- **Improved Theming:**
  - The design system upgrade includes enhancements to our theme, providing a more polished and unified aesthetic across different sections of the platform.

## Login Preferences

This enhancement allows you to effortlessly switch between organizations and preferred app (compute, storage and static site) while ensuring that your last login organization and app type are automatically saved upon logout. This ensures a personalized and efficient experience, as the platform will open with their preferred settings upon their next login.

## Discounts on Compute Templates

We introduced a brand-new feature that enhances your cost management capabilities. With this latest addition, users now have the ability to apply discounts on instance creation prices. Discounts are enabled on selected marketplace templates, offering you tailored options for optimizing resources and taking advantage of special promotions.

## Platform Improvements & Fixes

- **Performance Improvements:** We have optimized the platform's performance with reduced JavaScript chunk sizes, efficient code splitting, and implemented auto-cancellation for stale API calls.
- **Compute Usage Cost:** We have fixed the issue where incorrect instance usage prices were showing on the billing page.
- **Instance Deployment Status:** We have resolved the issue of deployment status not changing on successful instance deployment.
- **Persistent Storage Price:** We have rectified a intermittent issue of incorrect price being shown for persistent storage on instance creation page.
- **Delete Cluster:** We have fixed the issue of deleting a cluster when no name was provided during instance creation.
- **Spot Instances:** Spot instance deployment is now disabled by default. To enable it for your organization, contact our team at info@spheron.network.
- **Instance Configuration Fields:** We have enhanced the UI on instance creation configuration to display errors on required input fields.
  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
